import { render, staticRenderFns } from "./printBackground.vue?vue&type=template&id=a54645f2&scoped=true&"
import script from "./printBackground.vue?vue&type=script&lang=js&"
export * from "./printBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54645f2",
  null
  
)

export default component.exports